import React from 'react'
import JobList from '../components/job-list'
import Helmet from 'react-helmet'
import metaImage from '../assets/meta-image.png'

class IndexPage extends React.Component {
  render() {
    return (
      <div>
        <Helmet
          title={'ZAPGIGS'}
          meta={[
            {
              name: 'description',
              content: 'Discover the latest jobs in tech, all in one place 🎉',
            },
            {
              name: 'keywords',
              content:
                'Remote, Jobs, Remote Jobs, Developer Jobs, Tech Jobs, Technology, Online Jobs',
            },
            { property: 'og:title', content: 'ZAPGIGS' },
            {
              property: 'og:description',
              content: 'Discover the latest jobs in tech, all in one place 🎉',
            },
            {
              property: 'og:image',
              content: `https://www.zapgigs.com${metaImage}`,
            },
            {
              property: 'og:url',
              content: 'https://www.zapgigs.com/',
            },
            { name: 'twitter:card', content: 'summary_large_image' },

            { name: 'og:type', content: 'website' },
            { property: 'og:site_name', content: '⚡ZAPGIGS' },
            { name: 'twitter:image:alt', content: 'ZAPGIGS Logo' },
            {
              property: 'twitter:image',
              content: `https://www.zapgigs.com${metaImage}`,
            },

            { property: 'fb:app_id', content: 'app_id' },
            { name: 'twitter:site', content: '@zapgigsHQ' },
          ]}
        />
        <p style={{ color: 'hsla(210, 20%, 46%, 1)', textAlign: 'center' }}>
          Discover the latest jobs in tech, all in one place. 🎉
        </p>
        <JobList
          jobs={this.props.data.allJobsJson.edges}
          onScroll={this.handleScroll}
        />
      </div>
    )
  }
}

export default IndexPage

export const query = graphql`
  query JobQuery {
    allJobsJson(sort: { fields: [date], order: DESC }) {
      edges {
        node {
          date
          date_pretty
          slug
          company
          company_logo
          tags
          title
          description
          location
          url
          source {
            name
            homepage
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/index.js